const historyNavigationKeys = new Set();

// The listener is registered when the app creates its browser history.  A
// browser reload recreates this module without replaying a navigation event,
// so an existing history.state value cannot be mistaken for a new handoff.
export const trackInAppHistoryNavigation = history => history.listen((location, action) => {
  if (action === 'POP' && location && location.key) {
    historyNavigationKeys.add(location.key);
  }
});

export const wasReachedByInAppHistoryNavigation = location => (
  Boolean(location && location.key && historyNavigationKeys.has(location.key))
);
